// O contrato da URL entre a visão Assinaturas (que escreve a origem) e o detalhe da negociação
// (que a lê no "Voltar para a lista") mora aqui, e não numa das duas features: assim o detalhe não
// importa o barrel da visão, que poria a visão inteira no chunk dele (review COR-10).

/** `?visao=assinaturas` em `/negociacoes` abre direto a visão Assinaturas. */
export const VISAO_ASSINATURAS = 'assinaturas';

/** `?origem=assinaturas` no detalhe diz ao "Voltar para a lista" de onde a pessoa veio. */
const ORIGEM_ASSINATURAS = 'assinaturas';

/**
 * Destino do "Voltar para a lista" quando o detalhe foi aberto pela visão Assinaturas (decisão
 * "volta do detalhe"): a consulta vive no store e não reseta ao montar, então a visão reabre com a
 * busca, os filtros, o período e a página de antes.
 */
export const ROTA_DA_VISAO_ASSINATURAS = `/negociacoes?visao=${VISAO_ASSINATURAS}`;

/**
 * O endereço atual sem o `?visao=`, ou nulo quando ele não está lá. Ao sair da visão Assinaturas o
 * parâmetro sai da URL: senão recarregar a página, ou voltar a ela pelo histórico, reabriria
 * Assinaturas no lugar da visão escolhida (review COR-12).
 */
export function rotaSemAVisao(caminho: string, busca: string): string | null {
  const params = new URLSearchParams(busca);
  if (!params.has('visao')) return null;
  params.delete('visao');
  const query = params.toString();
  return query ? `${caminho}?${query}` : caminho;
}

export function rotaDoDetalheVindoDeAssinaturas(casoId: string): string {
  return `/negociacoes/${encodeURIComponent(casoId)}?origem=${ORIGEM_ASSINATURAS}`;
}

/** Aceita o `URLSearchParams` e o `ReadonlyURLSearchParams` do Next: só o `get` interessa. */
export function veioDaVisaoAssinaturas(params: Pick<URLSearchParams, 'get'>): boolean {
  return params.get('origem') === ORIGEM_ASSINATURAS;
}
